import cookie from 'react-cookie'
import {api} from '../config.js'
import moment from 'moment'

moment.locale('ru')

export const PUBLIC_CHAT_ID = 1
export const PRIVATE_CHAT_ID = 2
export const PROFILE_CHAT_ID = 3
export const INSURANCE_CHAT_ID = 4
export const PROFILE_PHOTO_CHAT_ID = 5
export const EXAM_CHAT_ID = 6
export const TEAM_CHAT_ID = 7
export const SMM_CHAT_ID = 8

export const CLOSE_CHAT = 'CLOSE_CHAT'
export const REQUEST_CHAT = 'REQUEST_CHAT'
export const RECEIVE_CHATS = 'RECEIVE_CHATS'
export const REQUEST_CHATS = 'REQUEST_CHATS'
export const CONCAT_PRIVATE_CHAT = 'CONCAT_PRIVATE_CHAT'
export const CONCAT_PUBLIC_CHAT = 'CONCAT_PUBLIC_CHAT'
export const CONCAT_TEAM_CHAT = 'CONCAT_TEAM_CHAT'
export const RENDER_PRIVATE_CHAT = 'RENDER_PRIVATE_CHAT'
export const RENDER_PUBLIC_CHAT = 'RENDER_PUBLIC_CHAT'
export const RENDER_TEAM_CHAT = 'RENDER_TEAM_CHAT'
export const RECEIVE_PRIVATE_CHAT = 'RECEIVE_PRIVATE_CHAT'
export const RECEIVE_PUBLIC_CHAT = 'RECEIVE_PUBLIC_CHAT'
export const RECEIVE_TEAM_CHAT = 'RECEIVE_TEAM_CHAT'
export const CHANGE_STATUS_CHAT = 'CHANGE_STATUS_CHAT'
export const CHANGE_CHAT_COMMENTS = 'CHANGE_CHAT_COMMENTS'
export const SET_UNREAD_COMMENTS = 'SET_UNREAD_COMMENTS'
export const SET_UNREAD_MSGS = 'SET_UNREAD_MSGS'
export const SET_SKIP_CHAT = 'SET_SKIP_CHAT'
const ITEMS_PER_PAGE = 50
let updateInstance

export const setUnReadMsgs = (unReadMsgs) => ({
  type: SET_UNREAD_MSGS,
  unReadMsgs
})

const commentGetAdminList = (authToken, data) => {
  return fetch(`${api}/user/comment-get-adminList`, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify({
      data,
      authToken
    })
  })
    .then(response => {
      return response.json()
    })
    .catch(console.error)
}

// CHAT LIST ACTIONS

const commentGetInfo = (authToken, data) => {
  return fetch(`${api}/user/comment-get-info`, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify({
      data,
      authToken
    })
  })
    .then(response => {
      //console.log(response)
      return response.json()
    })
    .catch(console.error)
}
export const adminChatCloseAction = () => ({
  type: 'ADMIN_CHAT_CLOSE'
})
export const adminChatOpenAction = () => ({
  type: 'ADMIN_CHAT_OPEN'
})
export const changeChatComments = (chat, data) => ({
  type: 'CHANGE_CHAT_COMMENTS',
  chat,
  data
})

export const setUnReadComments = (chat, data) => ({
  type: 'SET_UNREAD_COMMENTS',
  chat,
  data
})
export const setChatTypeId = chatTypeId => ({
  type: 'SET_CHAT_TYPE_ID',
  chatTypeId
})

export const setTypeId = typeId =>({
    type: 'SET_TYPE_ID',
    typeId
  })

export const setGroupId = groupId => ({
  type: 'SET_GROUP_ID',
  groupId
})
export const changeChatType = chatType => ({
  type: 'CHANGE_TYPE',
  chatType
})
export const changeStatusChatAction = payload => ({
  type: CHANGE_STATUS_CHAT,
  payload
})

export const requestChats = () => ({
  type: REQUEST_CHATS
})

export const receiveChats = (payload, pageCount) => ({
  type: RECEIVE_CHATS,
  payload,
  pageCount
})
export const setSkip = (chat) => ({
	type: SET_SKIP_CHAT,
  chat
})

const getChatTitle = ({ name, isPublic, userStarter }) => {
  let title

  if (isPublic) {
    title = name
  } else {
    const {firstName, lastName, programName, id} = userStarter

    title = `${id} - ${firstName} ${lastName}` // `[${id}] ${firstName} ${lastName}`

    if (programName) {
      title += ` / ${programName}`
    }

    if (name) {
      title += ` / ${name}`
    }
  }

  return title
}

export const fetchChats = (type, page = 1, user, userFilterText) => (dispatch, getState) => {
  dispatch(requestChats())

  const {userToken} = getState()
  const token = userToken.token || cookie.load('token')
  const userId = Number(cookie.load('user_id'))

  return commentGetAdminList(token, {
    type,
    take: ITEMS_PER_PAGE,
    skip: ITEMS_PER_PAGE * (page - 1),
    user,
    userFilterText
  })
    .then(chatsArray => {
      let flatChats = Array.prototype.concat.apply([], chatsArray.data)
        .map(({userStarter, ...chat}) => ({...chat, userStarter: userStarter || {}})) // Баг с null в userStarter
        .map(chat => {
          const title = getChatTitle(chat)
          const unread = chat.comments.length // TODO: Убрать когда придумаем способ чекать прочитанные
          const lastComment = chat.comments[unread - 1]
          const hasMessages = Boolean(lastComment)
          const isAnswered = lastComment ? lastComment.userInfo.id === userId : false
          const lastCommentDate = hasMessages ? moment(lastComment.date) : null

          return {
            ...chat,
            title,
            unread,
            isAnswered,
            hasMessages,
            updateTs: isAnswered ? 0 : (hasMessages ? (moment().valueOf() - lastCommentDate.valueOf()) : -1),
            timePassed: hasMessages ? lastCommentDate.fromNow(true) : '-'
          }
        })

      const pageCount = chatsArray.data.length > 0 ? Math.ceil(chatsArray.itemsCounter / ITEMS_PER_PAGE) : 0

      dispatch(receiveChats(flatChats, pageCount))
    })
}

export const fetchPublicChats = fetchChats(PUBLIC_CHAT_ID)
export const fetchPrivateChats = fetchChats(PRIVATE_CHAT_ID)
export const fetchProfileChats = fetchChats(PROFILE_CHAT_ID)
export const fetchInsuranceChats = fetchChats(INSURANCE_CHAT_ID)
export const fetchProfilePhotoChats = fetchChats(PROFILE_PHOTO_CHAT_ID)

// CHAT MESSAGES ACTIONS

export const requestChat = () => ({
  type: REQUEST_CHAT
})

export const receivePublicChatAction = (payload, counts, more) => ({
  type: RECEIVE_PUBLIC_CHAT,
  payload,
	counts,
  more
})

export const receivePrivateChatAction = (payload, counts, more) => ({
  type: RECEIVE_PRIVATE_CHAT,
  payload,
	counts,
  more
})
export const receiveTeamChatAction = (payload, counts, more) => ({
  type: RECEIVE_TEAM_CHAT,
  payload,
	counts,
  more
})
export const concatPrivateChatAction = payload => ({
  type: CONCAT_PRIVATE_CHAT,
  payload
})
export const concatTeamChatAction = payload => ({
  type: CONCAT_TEAM_CHAT,
  payload
})
export const concatPublicChatAction = payload => ({
  type: CONCAT_PUBLIC_CHAT,
  payload
})

export const renderPublicChatAction = payload => ({
  type: RENDER_PUBLIC_CHAT,
  payload
})
export const renderTeamChatAction = payload => ({
  type: RENDER_TEAM_CHAT,
  payload
})
export const renderPrivateChatAction = payload => ({
  type: RENDER_PRIVATE_CHAT,
  payload
})

export const clearRenderChat = () => ({
  type: 'CLEAR_RENDER_CHAT'
})

export const closeChat = () => (dispatch, getState) => {
  dispatch({
    type: CLOSE_CHAT
  })
}


export const fetchChat = (type, typeId, more, answer) => (dispatch, getState) => {
  dispatch(requestChat())
  const chat = getState().chat;
  let skip = 0;
  let take = 10;

  if(type == PRIVATE_CHAT_ID){
		take = answer ?  chat.privateChats.skip + chat.privateChats.take : chat.privateChats.take;
    skip = more ? chat.privateChats.skip + take :  answer ? 0 : chat.privateChats.skip;
  }
	if(type == TEAM_CHAT_ID){
		take = answer ? chat.teamChats.skip + chat.teamChats.take : chat.teamChats.take;
		skip = more ? chat.teamChats.skip + take : answer ? 0 :  chat.teamChats.skip;
	}
	if(type == PUBLIC_CHAT_ID){
		take = answer ? chat.publicChats.skip + chat.publicChats.take : chat.publicChats.take;
		skip = more ? chat.publicChats.skip + take : answer ? 0 : chat.publicChats.skip;
	}

  const {token} = getState().userToken;
  const data = typeId ? {type, typeId, skip, take} : {type, skip, take};

  return commentGetInfo(token || cookie.load('token'), data)
    .then((chats) => {
      if (chats.data[0]) {
        if (chats.data[0].isPublic) {
					if(more){
						dispatch(setSkip('publicChats'))
					}
          dispatch(receivePublicChatAction(chats.data[0], chats.itemsCounter, more));
        } else if(chats.data[0].type === 7){
					if(more){
						dispatch(setSkip('teamChats'))
					}
          dispatch(receiveTeamChatAction(chats.data[0], chats.itemsCounter, more));
        }
        else {
					if(more){
						dispatch(setSkip('privateChats'));
					}
          dispatch(receivePrivateChatAction(chats.data[0], chats.itemsCounter, more));
        }
      } else {
        dispatch(closeChat())
      }
    })
}

// CHAT METHODS

const chatMessageCreate = (authToken, data) => {
  return fetch(`${api}/user/chatmessage-create`, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify({
      data,
      authToken
    })
  })
    .then(response => {
      const res = response.json()
      return res
    })
    .catch(console.error)
}

export const createWithMessage = (type, typeId = null, text, isSystem = false) => (dispatch, getState) => {
  const {token} = getState().userToken
  const authToken = token || cookie.load('token')
  const data = typeId ? {type, recipient: typeId, text, isSystem} : {type, text, isSystem}
  // const data = {type, text, isSystem}

  return chatMessageCreate(authToken, data)
}

export const answerToChat = (group, text, type, typeId, reply) => (dispatch, getState) => {
  const {token} = getState().userToken
  const authToken = token || cookie.load('token')
  let data = typeId ? (group ? {group, text, type, typeId, reply} : {text, type, typeId, reply}) : {group, text, type, reply}
  return chatMessageCreate(authToken, data)
}

export const addToChat = (type, typeId, text) => (dispatch, getState) => {
  const {token} = getState().userToken
  const authToken = token || cookie.load('token')

  const data = typeId ? {type, typeId, text} : {type, text}

  return fetch(`${api}/user/chat-adduser`, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify({
      data,
      authToken
    })
  })
    .then(response => response.json())
    .catch(console.error)
}

export const waitingFromChat = (group) => (dispatch, getState) => {
  const {token} = getState().userToken
  const authToken = token || cookie.load('token')

  return chatMessageCreate(authToken, {group, status: 1})
}

export const answeredChat = (group) => (dispatch, getState) => {
  const {token} = getState().userToken
  const authToken = token || cookie.load('token')
  return chatMessageCreate(authToken, {group, status: 2})
}



// WEBPACK FOOTER //
// /var/www/build-health-2/src/actions/chats.js